<template>
    <div class="editPassword">
        <div class="title">相互宝快捷录入</div>
        <div class="content">
            <el-input v-model="dataStr" placeholder="请输入" type="textarea" :rows="14"></el-input>
        </div>
        <div class="btns">
            <el-button type="primary" @click="dataSubmit">确认提交</el-button>
        </div>
    </div>
</template>

<script>
import api from '../../../api/main'

export default {
    name: 'editPassword',
    data () {
        return {
            dataStr:'',
            
        }
    },
    created(){
    },
    mounted(){
        
    },
    computed:{
        
    },
    watch:{
        
    },
    methods:{
        async dataSubmit(){
            let res = await api.addQuickAsync({
                data:this.dataStr
            });
            if(res.data.code == '200'){
                this.dataStr = "";
                this.$message({
                    message: '提交成功',
                    type: 'success'
                });
            }
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    
    .editPassword{
        background-color: #ffffff;
        border-radius: 4px;
        padding-left: 80px;
        .title{
            color: #515a6e;
            font-weight: bold;
            font-size: 20px;
            padding: 20px 15px;
        }
        .content{
            width: 1000px;
            padding-left: 15px;
            padding-bottom: 30px;
            .item{
                margin-bottom: 20px;
                .item-t{
                    font-size: 15px;
                    color: #515a6e;
                    font-weight: bold;
                    margin-bottom: 12px;
                }
                .item-i{
                    width: 400px;
                }
            }
        }
        .btns{
            width: 600px;
            display: flex;
            flex-direction: row-reverse;
            padding-bottom: 30px;
        }
    }
</style>

